// extracted by mini-css-extract-plugin
module.exports = {"container":"TitleForm_container__2W8Us","buttons":"TitleForm_buttons__2JwKj","validateButton":"TitleForm_validateButton__1Vlax","cancelButton":"TitleForm_cancelButton__1iOSG"};